import {Form} from 'react-bootstrap';

const FormikSelectInputGroup = ({field, form, labelText, data}) => {
    const isValid = !form.errors[field.name];
    const isInvalid = form.touched[field.name] && !isValid;
    return (
        <Form.Group controlId={field.name} className="bdsm-input-group">
            <Form.Label>{labelText}</Form.Label>
            <Form.Select onChange={field.onChange}
                         value={field.value.value}
                         isValid={form.touched[field.name] && isValid}
                         isInvalid={isInvalid}
                         defaultValue={field.value}>
                {data.map((item) => {
                    return (
                        <option key={item.name} value={item.value}>
                            {item.name}
                        </option>
                    );
                })}
            </Form.Select>
            <Form.Control.Feedback type="invalid">
                {form.errors[field.name]}
            </Form.Control.Feedback>
        </Form.Group>
    );
};

export default FormikSelectInputGroup;
